'use client';
import * as React from 'react';
import Hls from 'hls.js';
import { useEffect } from 'react';

interface HLSVideoPlayerProps extends React.ComponentPropsWithRef<'video'> {
  playbackId: string;
}

export const MuxHLSVideo = React.forwardRef<
  HTMLVideoElement,
  HLSVideoPlayerProps
>(function MuxHLSVideo(
  props: HLSVideoPlayerProps,
  ref: React.ForwardedRef<HTMLVideoElement>
) {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const hlsRef = React.useRef<Hls>(null);
  const { playbackId, ...rest } = props;

  useEffect(() => {
    if (Hls.isSupported() && playbackId && videoRef.current) {
      //@ts-ignore
      hlsRef.current = new Hls({
        fetchSetup: function (context, initParams: RequestInit) {
          initParams.mode = 'no-cors';
          return new Request(context.url, initParams);
        },
      });
      hlsRef.current.loadSource(
        `https://stream.mux.com/${playbackId}.m3u8?redundant_streams=true`
      );
      hlsRef.current.attachMedia(videoRef.current);
    }

    return () => {
      if (hlsRef.current && videoRef.current) {
        hlsRef.current.detachMedia();
        hlsRef.current.destroy();
      }
    };
  }, [playbackId]);

  return (
    <video
      ref={(node) => {
        if (node) {
          //@ts-ignore
          videoRef.current = node;
        }

        if (ref) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            ref.current = node;
          }
        }
      }}
      {...rest}
      crossOrigin="anonymous"
    />
  );
});

export default MuxHLSVideo;
